"use strict";
/**
 * @packageDocumentation
 * @module DelegationNodeUtils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCheck = exports.countNodeDepth = exports.permissionsAsBitset = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("@kiltprotocol/utils");
const util_1 = require("@polkadot/util");
const DelegationNode_1 = tslib_1.__importDefault(require("./DelegationNode"));
/**
 * Creates a bitset from the permissions in the array where each enum value
 * is used to set the bit flag in the set.
 *
 * ATTEST has `0000000000000001`  (decimal 1).
 * DELEGATE has `0000000000000010` (decimal 2).
 *
 * Adding the enum values results in a decimal representation of the bitset.
 *
 * @param delegation The delegation from which you want to convert the permissions to bitset.
 * @returns The bitset as single value uint8 array.
 */
function permissionsAsBitset(delegation) {
    const permissionsBitsetData = delegation.permissions.reduce((accumulator, currentValue) => accumulator + currentValue);
    const uint8 = new Uint8Array(4);
    uint8[0] = permissionsBitsetData;
    return uint8;
}
exports.permissionsAsBitset = permissionsAsBitset;
async function countNodeDepth(attester, attestation) {
    let delegationTreeTraversalSteps = 0;
    // if the attester is not the owner, we need to check the delegation tree
    if (attestation.owner !== attester.address &&
        attestation.delegationId !== null) {
        delegationTreeTraversalSteps += 1;
        const delegationNode = await DelegationNode_1.default.query(attestation.delegationId);
        if (typeof delegationNode !== 'undefined' && delegationNode !== null) {
            const { steps, node } = await delegationNode.findAncestorOwnedBy(attester.address);
            delegationTreeTraversalSteps += steps;
            if (node === null) {
                throw utils_1.SDKErrors.ERROR_UNAUTHORIZED('Attester is not athorized to revoke this attestation. (attester not in delegation tree)');
            }
        }
    }
    else if (attestation.owner !== attester.address) {
        throw utils_1.SDKErrors.ERROR_UNAUTHORIZED('Attester is not athorized to revoke this attestation. (not the owner, no delegations)');
    }
    return delegationTreeTraversalSteps;
}
exports.countNodeDepth = countNodeDepth;
function errorCheck(delegationNodeInput) {
    const { permissions, rootId, parentId } = delegationNodeInput;
    if (permissions.length === 0 || permissions.length > 3) {
        throw utils_1.SDKErrors.ERROR_UNAUTHORIZED('Must have at least one permission and no more then two');
    }
    if (!rootId) {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_MISSING();
    }
    else if (typeof rootId !== 'string') {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
    }
    else if (!util_1.isHex(rootId)) {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
    }
    if (parentId) {
        if (typeof parentId !== 'string') {
            throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
        }
        else if (!util_1.isHex(parentId)) {
            throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
        }
    }
}
exports.errorCheck = errorCheck;
